module.exports = __webpack_public_path__ + "img/people.6ee4a0ea.svg";